import { render, staticRenderFns } from "./template_chapterpage.vue?vue&type=template&id=f74c4944&"
import script from "./template_chapterpage.vue?vue&type=script&lang=js&"
export * from "./template_chapterpage.vue?vue&type=script&lang=js&"
import style0 from "./template_chapterpage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports